module.exports = __webpack_public_path__ + "static/img/A-TFapple.d922ead.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/A-TFapple.png
// module id = kQuw
// module chunks = 3